import CryptoJS from 'crypto-js'; // Importing the crypto-js library

const secretKey = '@EngDave256#2??..**!<>ilefs'; // Use a very complex key for encryption

// Utility function to encrypt data
export const encryptData = (data) => {
  try {
    // Convert data to a JSON string and then encrypt it using AES
    return CryptoJS.AES.encrypt(JSON.stringify(data), secretKey).toString();
  } catch (error) {
    console.error("Encryption error:", error);
  }
};

// Utility function to decrypt data
export const decryptData = (encryptedData) => {
  try {
    // Decrypt data using AES
    const bytes = CryptoJS.AES.decrypt(encryptedData, secretKey);
    // Convert the decrypted bytes back to a JSON object
    return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
  } catch (error) {
    console.error("Decryption error:", error);
    return null;
  }
};

// Utility function to save to local storage
export const saveToLocalStorage = (key, data) => {
  const encryptedData = encryptData(data);
  if (encryptedData) {
    localStorage.setItem(key, encryptedData);
  }
};

// Utility function to retrieve and decrypt from local storage
export const getFromLocalStorage = (key) => {
  const encryptedData = localStorage.getItem(key);
  if (encryptedData) {
    return decryptData(encryptedData);
  }
  return null;
};

/*
<div>
    <h2>Encrypt & Decrypt Example</h2>
    <div>
        <input
            type="text"
            placeholder="Enter item to encrypt"
            value={item}
            onChange={(e) => setItem(e.target.value)}
        />
        <button onClick={handleSave}>Save Encrypted Item</button>
    </div>
    <div>
        <button onClick={handleRetrieve}>Retrieve & Decrypt Item</button>
        {retrievedItem && <p>Decrypted Item: {retrievedItem}</p>}
    </div>
</div>
*/